var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftLoginIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x37_8-microsoft",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.999,
    height: 17.999,
    viewBox: "0 0 17.999 17.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3168",
    "data-name": "Group 3168",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3167",
    "data-name": "Group 3167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M270.912,25.247h8.474v-7.93a.566.566,0,0,0-.565-.567h-7.909Zm0,0",
    transform: "translate(-261.387 -16.75)",
    fill: "#5acf5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M25.871,25.247v-8.5H17.962a.566.566,0,0,0-.565.567v7.93h8.474Zm0,0",
    transform: "translate(-17.397 -16.75)",
    fill: "#f84437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M25.871,270.953H17.4v7.93a.566.566,0,0,0,.565.567h7.909Zm0,0",
    transform: "translate(-17.397 -261.451)",
    fill: "#2299f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M270.912,270.953v8.5h7.909a.566.566,0,0,0,.565-.567v-7.93Zm0,0",
    transform: "translate(-261.387 -261.451)",
    fill: "#ffc107"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftLoginIcon);
export default __webpack_public_path__ + "static/media/microsoft-login-icon.7abd6fe5b157620f3ee96936c14979ec.svg";
export { ForwardRef as ReactComponent };